import React from "react";
import { Dialog } from "Components/Base/Feedback/Dialog";
import { DialogActions } from "Components/Base/Feedback/DialogActions";
import { DialogTitle } from "Components/Base/Feedback/DialogTitle";
import { DialogContent } from "Components/Base/Feedback/DialogContent";
import { Button } from "Components/Base/Inputs/Button";

const Alert = ({ confirmText, handleConfirm, title, text, open }) => {
  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      aria-labelledby="alert-title"
      open={open}
      data-testid="alert-component"
    >
      <DialogTitle id="alert-title">{title}</DialogTitle>
      <DialogContent id="alert-description">{text}</DialogContent>
      <DialogActions>
        <Button
          onClick={handleConfirm}
          id="alert-confirm-button"
          label={confirmText}
        />
      </DialogActions>
    </Dialog>
  );
};

export default Alert;
